import React from 'react';
import {
  DialogContentText as MuiDialogContentText,
  DialogContentTextProps as MuiDialogContentTextProps,
} from '@mui/material';

type DialogContentTextBlockedProps = keyof Pick<
  MuiDialogContentTextProps,
  'color'
>;

export type DialogContentTextProps = Omit<
  MuiDialogContentTextProps,
  DialogContentTextBlockedProps
> & {
  /**
   * @deprecated Unsupported prop: Use `sx` with tokens to set the color.
   * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this prop.
   */
  color?: MuiDialogContentTextProps['color'];
};

/**
 * DialogContentText displays styled text content within a DialogContent area.
 *
 * Demos:
 *
 * - [Dialog — Content Text](https://unify.workiva.org/components/dialog?tab=code)
 *
 * API:
 *
 * - [DialogContentText API](https://unify.workiva.org/components/dialog?tab=props#dialogcontenttext)
 */
export const DialogContentText = React.forwardRef<
  HTMLElement,
  DialogContentTextProps
>(function UnifyDialogContentText(props, ref) {
  return <MuiDialogContentText {...props} ref={ref} />;
});
